import { ISetDayLogicModifiers, Type } from "./CrewSchedule.Actions";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { IRootState } from "../../reducers/CombinedReducers";
import { IWebsocketCLMUpdate, ICrewLogicModifier } from "@vmosolutions/oc-interfaces";
import _ from "lodash";
import { ICrewLogicModifierMap, updateCrewDayLogicModifiers } from "../../reducers/CrewScheduleReducer";

/**
 * setDayLogicModifiers - Redux action to set the day logic modifier map
 * @param crewDayLogicModifiers - ICrewLogicModifierMap the map of all crew logic modifiers.
 * A map of crew ids that goes to the map of a day month string with value of array of logic modifiers
 */
export const setDayLogicModifiers = (crewDayLogicModifiers: ICrewLogicModifierMap): ISetDayLogicModifiers => {
  return {
    type: Type.SET_DAY_LOGIC_MODIFIERS,
    crewDayLogicModifiers,
  };
};

/**
 * websocketUpdatedCLM - Updates redux with the new crew logic modifier.
 * @param clmUpdate - IWebsocketCLMUpdate the oldCLM event to remove from redux and the newCLM event to add to redux
 */
export const websocketUpdatedCLM = (
  clmUpdate: IWebsocketCLMUpdate
): ThunkAction<void, IRootState, object, ISetDayLogicModifiers> => {
  return (dispatch: ThunkDispatch<IRootState, object, ISetDayLogicModifiers>, getState: () => IRootState): void => {
    let crewDayLogicModifiers = _.cloneDeep(getState().crewSchedule.crewDayLogicModifiers);
    const { oldCLM, newCLM } = clmUpdate;
    if (oldCLM) {
      const dayLMs = crewDayLogicModifiers[oldCLM.crew_id];
      const dayLMDate = new Date(oldCLM.date);
      const dayMonthStr = `${dayLMDate.getUTCFullYear()}-${dayLMDate.getUTCMonth() + 1}-${dayLMDate.getUTCDate()}`;
      // The crew member may have no modifiers loaded (e.g. outside the fetched range), so there may be nothing to remove.
      const dayLM = dayLMs?.[dayMonthStr];
      if (dayLM) {
        crewDayLogicModifiers[oldCLM.crew_id][dayMonthStr] = dayLM.filter(
          (clm: ICrewLogicModifier) => clm._id !== oldCLM._id
        );
      }
    }

    if (newCLM) {
      crewDayLogicModifiers = updateCrewDayLogicModifiers(crewDayLogicModifiers, [newCLM]);
    }
    dispatch(setDayLogicModifiers(crewDayLogicModifiers));
  };
};
